

























import Vue from "vue";
import _icons from "../../services/icons";
import MenuSubclassComp from "./MenuSubclassComp.vue";
import { Class } from "models/Klasse";
// eslint-disable-next-line @typescript-eslint/no-var-requires
const whatInput = require("what-input");

export default Vue.extend({
	name: "MenuClassComp",
	components: { MenuSubclassComp },
	data: () => ({
		classes: [
			{ id: 1, abbr: "Ele" },
			{ id: 2, abbr: "Mes" },
			{ id: 3, abbr: "Nec" },
			{ id: 4, abbr: "Rgr" },
			{ id: 5, abbr: "Eng" },
			{ id: 6, abbr: "Thf" },
			{ id: 7, abbr: "War" },
			{ id: 8, abbr: "Gdn" },
			{ id: 9, abbr: "Rev" },
		],
		isTouch: false,
	}),
	methods: {
		classIcon: function(name: string): string {
			return _icons.classIcon(name);
		},
		pick: function(clss: Class): void {
			this.$emit("pick", clss);
		},
	},
	created: function(): void {
		this.isTouch = whatInput.ask() === "touch";
	},
});
